import http from 'plugins/axios';

export default {

  //更新后的查询所有用户信息
  getUserList(data) {
    return http.get({
      url: '/ta/admin/tenant/user/userLoginLog',
      data
    })
  },

  exportUserLoginLog(data) {
    return http.get({
      url: '/ta/admin/tenant/user/userLoginLog/export',
      data,
      responseType: 'blob',
    })
  },


};
